module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/The-Hot-Zone.0df8833.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/The-Hot-Zone.jpg
// module id = 0aa5
// module chunks = 0